import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

export const useListingManagerImageGalleryFeatureFlag = () => {
  const featureFlagName = 'listing-manager-image-gallery';
  const editFeatureFlagName = 'listing-manager-image-gallery-edit';
  const { user } = useUser();

  const { data: featureFlags, isLoading } = useFeatureFlags([featureFlagName, editFeatureFlagName], {
    user_email: user?.email || '',
  });

  return {
    isLoading,
    isListingManagerImageGalleryEnabled: featureFlags?.[featureFlagName] === 'on',
    isListingManagerImageGalleryEditEnabled: featureFlags?.[editFeatureFlagName] === 'on',
  };
};
